import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function FulfillmentStepAPI(): BringozApi {
  return {
    base: `/fulfillment/{fulfillmentId}/step`,
    infiniteScroll: {
      address: `/fulfillment/{fulfillmentId}/step`,
      cmd: 'GET'
    },
    actions: {
    }
  }
}

angular
  .module('bringoz.admin.fulfillment')
  .factory('FulfillmentStepAPI', FulfillmentStepAPI);
